<template>
  <v-row class="contest-card">
    <v-col md="6" sm="6" lg="4" v-for="(contest, index) in allcontests" :key="contest.id">
      <v-card class="elevation-0 pa-0 rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
        <v-img height="172px" :src="cardImg">
          <div class="text-right pt-2 pr-2">
            <v-menu rounded="0" transition="slide-x-transition" bottom left>
              <template v-slot:activator="{ attrs, on }">
                <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on" icon>
                  <v-icon color="#fff">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-card class="dropdown-menu-card" tile flat>
                <v-list flat outlined :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'">
                  <v-list-item-group>
                    <v-list-item :ripple="false" v-if="contest.status === 'Waiting to Start'">
                      <v-list-item-content>
                        <v-list-item-title>
                          <edit-contest-modal :contest="contest" :allacctypes="allacctypes"></edit-contest-modal>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :ripple="false" link>
                      <v-list-item-content>
                        <router-link class="text-decoration-none" :to="getContestRoute(contest)">
                          See Details
                        </router-link>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </div>
          <div class="contest-details-wrapper">
            <div class="content">
              <div class="title mb-3">
                <h3>Contest {{ index + 1 }}</h3>
                <p>{{ contest.contest_name }}</p>
              </div>
              <div class="price">
                <h3>Total Prize Worth</h3>
                <h4>$<span>{{ contest.total_prize_worth }}</span></h4>
              </div>
            </div>
            <div class="prize-wrapper">
              <div v-for="(prize, idx) in contest.prizes.slice(0, 3)" :key="idx" class="prize">
                <div class="prize-label">
                  <v-avatar size="42">
                    <v-img
                      :src="`https://ui-avatars.com/api/?name=${contest?.contest_name}&background=random` || require('@/assets/cup.png')"></v-img>
                  </v-avatar>
                  <span class="number">{{ idx + 1 }}</span>
                </div>
                <div class="prize-amount">
                  <h5>{{ prize }}</h5>
                </div>
              </div>
            </div>
          </div>
        </v-img>
        <div class="card-content">
          <v-card-actions>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <h2 :class="getStatusClass(contest.status)">{{ contest.status }}</h2>
              </v-col>
              <v-col cols="12" sm="6">
                <h3>Contestant : <span>{{ contest?.total_contestants || 0 }}</span></h3>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Deposit Amount</span>
                  <span>${{ contest.contest_money }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Total Prize Worth</span>
                  <span>${{ contest.total_prize_worth }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>Start Time </span>
                  <span>{{ contest.formatted_start_date }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="currency-leverage">
                  <span>End Time</span>
                  <span>{{ contest.formatted_end_date }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions>
            <v-btn :ripple="false" block tile :outlined="contest.status !== 'Waiting to Start'" large elevation="0"
              :to="getContestRoute(contest)" :class="getButtonClass(contest.status)"
              :color="getButtonColor(contest.status)">
              <v-icon v-if="contest.status !== 'Waiting to Start'" :class="getButtonIconClass(contest.status)"
                :color="getButtonIconColorClass(contest.status)" :large="contest.status === 'Contest Finished'">
                mdi-circle-small
              </v-icon>
              See Details
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import EditContestModal from "./EditContestModal.vue";
import { mapActions, mapState } from "vuex";
import { CONTEST__ACTIONS } from "@/store/action-types";

export default {
  name: 'ContestCards',
  data() {
    return {
      cardImg: require('@/assets/contest-card.png')
    }
  },
  components: { EditContestModal },
  computed: {
    ...mapState("contest", ["allcontests", "allacctypes"]),
  },
  methods: {
    ...mapActions("contest", [CONTEST__ACTIONS.GETALLCONTEST, CONTEST__ACTIONS.GETALLCONTESTACCTYPES]),

    getStatusClass(status) {
      switch (status) {
        case 'Waiting to Start':
          return 'bg-warning';
        case 'Running Contest':
          return 'bg-success';
        case 'Contest Finished':
          return 'bg-danger';
        default:
          return '';
      }
    },

    getButtonClass(status) {
      return status === 'Waiting to Start' ? 'custom-btn' : status === 'Running Contest' ? 'custom-btn-outline' : 'custom-btn-outline';
    },

    getButtonColor(status) {
      return status === 'Waiting to Start' ? '#039de9' : status === 'Running Contest' ? '#ffffff' : '#ffffff';
    },

    getButtonIconClass(status) {
      return status === 'Waiting to Start' ? 'd-none' : status === 'Running Contest' ? 'blink' : '';
    },

    getButtonIconColorClass(status) {
      return status === 'Waiting to Start' ? '' : status === 'Running Contest' ? '#039de9' : '#647E98';
    },

    getContestRoute(contest) {
      switch (contest.status) {
        case 'Waiting to Start':
          return `/pending-contest?id=${contest.id}`;
        case 'Running Contest':
          return `/running-contest?id=${contest.id}`;
        case 'Contest Finished':
          return `/finished-contest?id=${contest.id}`;
        default:
          return '/';
      }
    },
  },
  async mounted() {
    await this[CONTEST__ACTIONS.GETALLCONTEST]();
    await this[CONTEST__ACTIONS.GETALLCONTESTACCTYPES]();
  },
}
</script>